import axios, { endpoints } from 'src/utils/axios';

export const get_exercises_dashboard = async () => {
  try {
    const res = await axios.get(`${endpoints.program.get_exercises_dashboard}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting breakdown:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const AddLibraryProgram = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.library.add_library_program,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// EDIT PROGRAM
export const EditLibraryProgram = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.library.edit_library_program,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// DELETE LIBRARY PROGRAM
export const delete_library_program = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_library_program}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting exercise:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET MEMBER PROGRAMS
export const get_library_programs = async ({ search, tab_id, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_library_programs}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET PROGRAM DETAILS
export const get_library_program_detail = async ({ id, is_trail }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id || is_trail) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (is_trail) params.append('is_trail', is_trail);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_library_program_details}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE PROGRAM
export const delete_library_week = async ({ id, original_id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    if (original_id) params.append('original_id', original_id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_week}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// INDIVIDUAL EXERCISES
export const get_individual_exercises = async ({ search, tab_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_individual_exercises}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting individual exercises:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const add_library_exercise = async (exercise_data) => {
  try {
    const res = await axios.post(
      endpoints.library.save_individual_exercise,
      exercise_data, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET INDIVIDUAL EXERCISE DETAILS
export const get_individual_exercise_detail = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(
      `${endpoints.library.get_individual_exercise_detail}${queryParams}`
    );
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE INDIVIDUAL EXERCISE
export const delete_individual_exercise = async ({ id, original_id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_individual_exercise}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting exercise:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// INDIVIDUAL EXERCISE DETAILS

// TRAINER LIBRARY PROGRAMS
export const get_library_trainer_programs = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_library_trainer_programs}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET WORKOUT COMMENTS
export const get_workout_comments = async ({ exercise_id, activity_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (exercise_id) {
      const params = new URLSearchParams();
      if (exercise_id) params.append('exercise_id', exercise_id);
      if (activity_id) params.append('activity_id', activity_id);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_workout_comments}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ACTIVITY BUNDLES

// GET ACTIVITY BUNDLES
export const get_activity_bundles = async ({ search, status, tab_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_activity_bundles}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD ACTIVITY BUNDLE
export const add_activity_bundle = async ({ name, exercise_ids, id, tab_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    name && formData.append('name', name);
    exercise_ids && formData.append('exercise_ids', exercise_ids);
    tab_id && formData.append('custom_tab_id', tab_id);

    const res = await axios.post(endpoints.library.add_activity_bundle, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error Adding Activity Bundle:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET ACTIVITY BUNDLE DETAILS
export const get_activity_bundle_details = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_activity_bundle_details}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting activity bundle details:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE ACTIVITY BUNDLE
export const delete_activity_bundle = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_activity_bundle}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting activity bundle:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// ADD COMMENT MEDIA
export const AddMemberCommentMedia = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.add_comment_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD COMMENT
export const AddMemberComment = async ({ parent_id, exercise_id, comment, comment_media_ids }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    exercise_id && formData.append('exercise_id', exercise_id);
    parent_id && formData.append('parent_id', parent_id);

    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.add_comment, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE COMMENT
export const delete_note_by_type = async ({ id, entity_type }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    if (entity_type) params.append('entity_type', entity_type);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_comment_by_type}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting comment:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET SET COMMENTS
export const get_set_comments = async ({ set_id, activity_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (set_id || activity_id) {
      const params = new URLSearchParams();
      if (set_id) params.append('set_id', set_id);
      if (activity_id) params.append('activity_id', activity_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_set_comments}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD COMMENT MEDIA SET
export const AddMemberCommentMedia_set = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.add_set_comment_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD COMMENT
export const AddMemberComment_set = async ({ parent_id, set_id, comment, comment_media_ids }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    set_id && formData.append('set_id', set_id);
    parent_id && formData.append('parent_id', parent_id);

    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.add_set_comment, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// NUTRITION API SERVICES

export const get_nutrition_dashboard = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_nutrition_dashboard}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting stats:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// MEMBER TAB

export const get_library_programs_plate = async ({ search, status, tab_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_library_programs_plate}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const delete_library_program_plate = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_library_program}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting exercise:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// ADD LIBRARY PROGRAM PLATE
export const AddLibraryProgramPlate = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.library.add_library_program_plate,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// EDIT PROGRAM
export const EditLibraryProgramPlate = async (programData) => {
  try {
    const res = await axios.post(
      endpoints.library.edit_library_program_plate,
      programData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET PROGRAM DETAILS
export const get_library_program_detail_plate = async ({ id, is_trail }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id || is_trail) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (is_trail) params.append('is_trail', is_trail);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(
      `${endpoints.library.get_library_program_details_plate}${queryParams}`
    );
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE PROGRAM
export const delete_library_week_plate = async ({ id, original_id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    if (original_id) params.append('original_id', original_id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_week_plate}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting trainer:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET TRAINER PROGRAMS PLATE
export const get_library_trainer_programs_plate = async ({ search, status }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(
      `${endpoints.library.get_library_trainer_programs_plate}${queryParams}`
    );
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting train programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET LOG COMMENTS
export const get_log_comments = async ({ log_id, activity_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (log_id) {
      const params = new URLSearchParams();
      if (log_id) params.append('member_day_food_dish_id', log_id);
      if (activity_id) params.append('activity_id', activity_id);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_log_comments}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD INDIVIDUAL FOOD ITEMS
export const add_individual_food_item = async (foodData) => {
  try {
    const res = await axios.post(
      endpoints.library.add_food_item,
      foodData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET ALL NUTRIENTS

export const get_all_nutrients = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_nutrients}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting trainers:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET ALL FOOD ITEMS
export const get_all_food_items = async ({ search, tab_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_all_food_items}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE FOOD ITEM
export const delete_food_item = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_food_item}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting food item:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET FOOD ITEM DETAILS
export const get_food_item_details = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_food_item_detail}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting food item detail:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DISHES

// ADD DISH
export const add_dish = async (dishData) => {
  try {
    const res = await axios.post(
      endpoints.library.add_dish,
      dishData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET ALL FOOD ITEMS
export const get_all_dishes = async ({ search, tab_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_all_dishes}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting dishes:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET ALL FOOD ITEMS
export const get_all_dishes_meal = async () => {
  try {
    // Build query params conditionally

    const res = await axios.get(`${endpoints.library.get_all_dishes_meal}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting dishes:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET ALL FOOD ITEMS
export const get_dish_breakdown = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);
    queryParams = `?${params.toString()}`;

    const res = await axios.get(`${endpoints.library.get_dish_breakdown}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting dishes:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE FOOD ITEM
export const delete_dish = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_dish}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting dish:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET FOOD ITEM DETAILS
export const get_dish_details = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_dish_detail}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting dish detail:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD NUTRITION PLAN
export const add_nutrition_plan = async (nutritionData) => {
  try {
    const res = await axios.post(
      endpoints.library.add_nutrition_plan,
      nutritionData, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error adding program:', error);
    throw error;
  }
};

// GET ALL NUTRIENT PLANS
export const get_all_nutrient_plan = async ({ search, tab_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_all_nutrient_plan}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting dishes:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE FOOD ITEM
export const delete_nutrition_plan = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_nutrition_plan}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting nutrition plan:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET MEALS
export const get_meals = async ({ search, status, tab_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (search || status || tab_id) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (status) params.append('status', status);
      if (tab_id) params.append('custom_tab_id', tab_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_meals}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting meals:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD MEAL
export const add_meal = async ({ name, entity_ids, id, tab_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    name && formData.append('name', name);
    entity_ids && formData.append('entity_ids', entity_ids);
    tab_id && formData.append('custom_tab_id', tab_id);
    const res = await axios.post(endpoints.library.add_meals, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error Adding Meal:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET MEAL DETAILS
export const get_meal_detail = async ({ id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_meal_details}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting meal details:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE MEAL
export const delete_meal = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_meals}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting meal:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// CUSTOM TAB

// ADD MEAL
export const add_edit_custom_tab = async ({ id, name }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    name && formData.append('name', name);
    const res = await axios.post(endpoints.library.add_custom_tab, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error Custom Tab:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET CUSTOM TABS
export const get_custom_tabs = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_custom_tab}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting meals:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE CUSTOM TAB
export const delete_custom_tab = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_custom_tab}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting meal:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET CUSTOM TABS
export const get_custom_media = async ({ search, tab_id, type }) => {
  try {
    let queryParams = '';
    if (search || tab_id || type) {
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (tab_id) params.append('custom_tab_id', tab_id);
      if (type) params.append('type', type);

      queryParams = `?${params.toString()}`;
    }
    const res = await axios.get(`${endpoints.library.get_custom_media}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting media:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD CUSTOM MEDIA ( IMAGE OR VIDEO )
export const add_custom_media = async ({ name, type, media, tab_id, thumbnail }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line

    tab_id && formData.append('custom_tab_id', tab_id);
    type && formData.append('type', type); // image or video
    name && formData.append('name', name);
    media && media !== undefined && formData.append('media', media); // Add the media directly
    thumbnail && thumbnail !== undefined && formData.append('thumbnail', thumbnail); // Add the file directly

    const res = await axios.post(endpoints.library.add_custom_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error Adding Custom Media:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// DELETE CUSTOM MEDIA
export const delete_custom_media = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(`${endpoints.library.delete_custom_media}${queryParams}`); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting media:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

//  const formData = new FormData();

//     file && file !== undefined && formData.append('media', file); // Add the file directly
//     thumbnail && thumbnail !== undefined && formData.append('thumbnail', thumbnail); // Add the file directly

// ADD NUTRIENT PLAN TO LIBRARY
export const add_nutrient_plan_to_library = async ({
  program_day_trial_id,
  program_id,
  name,
  is_copy,
  custom_tab_id,
}) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_day_trial_id && formData.append('program_day_trail_id', program_day_trial_id);
    program_id && formData.append('program_id', program_id);
    name && formData.append('name', name);
    is_copy && formData.append('is_copy', is_copy);
    custom_tab_id &&
      custom_tab_id !== 'exercise_library' &&
      custom_tab_id !== 'nutrition_library' &&
      formData.append('custom_tab_id', custom_tab_id);

    const res = await axios.post(endpoints.library.add_nutrient_plan_to_library, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding exercise to library', error);
    throw error;
  }
};

// GET ALL MEMBER PROGRAMS
export const get_all_workout_program = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_workout_programs}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// IMPORT PROGRAM
export const import_program = async ({ program_id, start_date, include_notes }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('library_program_id', program_id);
    start_date && formData.append('start_date', start_date);
    include_notes && formData.append('include_notes', include_notes);

    const res = await axios.post(endpoints.library.import_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during importing', error);
    throw error;
  }
};

// GET ALL PLATE PROGRAMS
export const get_all_plate_program = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_plate_programs}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// IMPORT PROGRAM
export const import_plate_program = async ({ program_id, start_date }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    program_id && formData.append('library_program_id', program_id);
    start_date && formData.append('start_date', start_date);

    const res = await axios.post(endpoints.library.import_plate_program, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during importing', error);
    throw error;
  }
};

// GET ALL WORKOUTS
export const get_all_workouts = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_workouts}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// GET ALL WORKOUTS
export const get_all_workouts_activity_bundle = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_exercises}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// IMPORT PROGRAM
export const import_workout = async ({ library_exercise_id, day_id, program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    library_exercise_id && formData.append('library_exercise_id', library_exercise_id);
    day_id && formData.append('day_id', day_id);
    program_id && formData.append('program_trail_id', program_id);
    formData.append('include_notes', true);

    const res = await axios.post(endpoints.library.import_workout, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during importing', error);
    throw error;
  }
};

// GET ALL ACTIVITY BUNDLE
export const get_all_bundles = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_bundles}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// IMPORT ACTIVITY BUNDLES
export const import_bundles = async ({ activity_bundle_id, day_id, program_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    activity_bundle_id && formData.append('activity_bundle_id', activity_bundle_id);
    day_id && formData.append('day_id', day_id);
    program_id && formData.append('program_trail_id', program_id);
    formData.append('include_notes', true);

    const res = await axios.post(endpoints.library.import_bundle, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during importing', error);
    throw error;
  }
};

// GET ALL ACTIVITY BUNDLE
export const get_all_nutrition_plans = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_nutrition_plans}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting nutrition plan:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// IMPORT ACTIVITY BUNDLES
export const import_nutrition_plan = async ({
  library_nutrition_plan_id,
  day_id,
  program_id,
  is_overwrite,
}) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    library_nutrition_plan_id &&
      formData.append('library_nutrition_plan_id', library_nutrition_plan_id);
    day_id && formData.append('day_id', day_id);
    program_id && formData.append('program_trail_id', program_id);
    is_overwrite && formData.append('is_overwrite', is_overwrite);

    const res = await axios.post(endpoints.library.import_nutrition_plan, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during importing', error);
    throw error;
  }
};

// GET ALL WORKOUTS
export const get_all_foods = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_foods}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// IMPORT PROGRAM
export const import_food = async ({ library_fooditem_ids }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    library_fooditem_ids && formData.append('library_fooditem_ids', library_fooditem_ids);

    const res = await axios.post(endpoints.library.import_food, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during importing', error);
    throw error;
  }
};

// GET ALL WORKOUTS
export const get_all_dish = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_dish}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// IMPORT PROGRAM
export const import_dish = async ({ library_dish_ids }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    library_dish_ids && formData.append('library_dish_ids', library_dish_ids);

    const res = await axios.post(endpoints.library.import_dish, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error during importing', error);
    throw error;
  }
};

// ADD NUTRIENT PLAN TO LIBRARY
export const library_highlights_toggle = async ({ id, type }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    type && formData.append('type', type);

    const res = await axios.post(endpoints.library.library_highlights_toggle, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding to library highlights', error);
    throw error;
  }
};

// COPY OR MOVE ENTITIES TO ANOTHER TAB
export const copy_or_move_entity_tab = async ({ id, type, is_move, custom_tab_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    type && formData.append('type', type);
    is_move && formData.append('is_move', is_move);
    custom_tab_id &&
      custom_tab_id !== 'exercise_library' &&
      custom_tab_id !== 'nutrition_library' &&
      formData.append('custom_tab_id', custom_tab_id);

    const res = await axios.post(endpoints.library.move_or_copy, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    // Return response data for further handling
    return res?.data;
  } catch (error) {
    console.error('Error copy or move', error);
    throw error;
  }
};

export const get_all_logs = async ({ is_favorite }) => {
  try {
    let queryParams = '';
    if (is_favorite) {
      const params = new URLSearchParams();
      if (is_favorite) params.append('is_favorite', is_favorite);
      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_logs_history}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting programs:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// COPY OR MOVE ENTITIES TO ANOTHER TAB
export const log_toggle = async ({ id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);

    const res = await axios.post(endpoints.library.log_toggle, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    // Return response data for further handling
    return res?.data;
  } catch (error) {
    console.error('Error while saving', error);
    throw error;
  }
};

export const replicate_log = async ({ id, day_id }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    day_id && formData.append('day_id', day_id);

    const res = await axios.post(endpoints.library.replicate_food_log, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        // Specify multipart form data for file uploads
      },
    });
    // Return response data for further handling
    return res?.data;
  } catch (error) {
    console.error('Error while saving', error);
    throw error;
  }
};

// ADD NUTRIENT PLAN TO LIBRARY
export const pin_entity = async ({ id, type }) => {
  try {
    const formData = new FormData();
    // eslint-disable-next-line
    id && formData.append('id', id);
    type && formData.append('type', type);

    const res = await axios.post(endpoints.program.pin_entity, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Specify multipart form data for file uploads
      },
    });
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error adding to library highlights', error);
    throw error;
  }
};

// GET HISTORY NOTES
export const get_history_notes = async ({ id, exercise_id }) => {
  try {
    let queryParams = '';
    if (id || exercise_id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (exercise_id) params.append('exercise_id', exercise_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_history_notes}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting notes history:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const import_history_notes = async (data) => {
  try {
    const res = await axios.post(
      endpoints.library.import_history_note,
      data, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error importing notes:', error);
    throw error;
  }
};

export const get_set_history_notes = async ({ id, set_id }) => {
  try {
    let queryParams = '';
    if (id || set_id) {
      const params = new URLSearchParams();
      if (id) params.append('id', id);
      if (set_id) params.append('set_id', set_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_set_history_notes}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting notes history:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const import_set_history_notes = async (data) => {
  try {
    const res = await axios.post(
      endpoints.library.import_set_history_note,
      data, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error importing notes:', error);
    throw error;
  }
};

export const get_notes_history = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_notes_history}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting notes history:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const get_all_notes_food_history = async () => {
  try {
    const res = await axios.get(`${endpoints.library.get_all_notes_food_history}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting log notes history:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

export const import_notes_history = async (data) => {
  try {
    const res = await axios.post(
      endpoints.library.import_notes_history,
      data, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error importing notes:', error);
    throw error;
  }
};

export const import_food_notes_history = async (data) => {
  try {
    const res = await axios.post(
      endpoints.library.import_food_notes_history,
      data, // valid JSON object
      {
        headers: {
          'Content-Type': 'application/json', // optional (axios sets this by default for objects)
        },
      }
    );

    return res.data;
  } catch (error) {
    console.error('Error importing notes:', error);
    throw error;
  }
};

// DELETE LIBRARY FOOD ITEM COMMENT
export const delete_library_food_comment = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(
      `${endpoints.library.delete_nutrition_food_item_comment}${queryParams}`
    ); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting comment:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET LIBRARY FOOD ITEM COMMENTS
export const get_library_food_comments = async ({ food_item_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (food_item_id) {
      const params = new URLSearchParams();
      if (food_item_id) params.append('food_item_id', food_item_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(
      `${endpoints.library.get_nutrition_food_item_comments}${queryParams}`
    );
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD LIBRARY FOOD ITEM COMMENT MEDIA ( IMAGE OR VIDEO )
export const add_library_food_comment_media = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(
      endpoints.library?.upload_nutrition_food_item_comment_media,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
        },
      }
    );
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD LIBRARY FOOD ITEM COMMENT
export const add_library_food_comment = async ({
  parent_id,
  food_item_id,
  comment,
  comment_media_ids,
}) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    food_item_id && formData.append('food_item_id', food_item_id);
    parent_id && formData.append('parent_id', parent_id);
    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.save_nutrition_food_item_comment, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE LIBRARY DISH ITEM COMMENT
export const delete_library_dish_comment = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(
      `${endpoints.library.delete_nutrition_dish_comment}${queryParams}`
    ); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting comment:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET LIBRARY DISH ITEM COMMENTS
export const get_library_dish_comments = async ({ dish_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (dish_id) {
      const params = new URLSearchParams();
      if (dish_id) params.append('dish_id', dish_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_nutrition_dish_comments}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD LIBRARY DISH ITEM COMMENT MEDIA ( IMAGE OR VIDEO )
export const add_library_dish_comment_media = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.upload_nutrition_dish_comment_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD LIBRARY DISH ITEM COMMENT
export const add_library_dish_comment = async ({
  parent_id,
  dish_id,
  comment,
  comment_media_ids,
}) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    dish_id && formData.append('dish_id', dish_id);
    parent_id && formData.append('parent_id', parent_id);
    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.save_nutrition_dish_comment, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// DELETE LIBRARY MEAL ITEM COMMENT
export const delete_library_meal_comment = async ({ id }) => {
  try {
    let queryParams = '';
    const params = new URLSearchParams();
    if (id) params.append('id', id);

    queryParams = `?${params.toString()}`;
    const res = await axios.delete(
      `${endpoints.library.delete_nutrition_meal_comment}${queryParams}`
    ); // Append id to the endpoint
    return res?.data; // Return response data for further handling
  } catch (error) {
    console.error('Error deleting comment:', error); // Updated error message
    throw error; // Rethrow error for handling in the UI
  }
};

// GET LIBRARY MEAL ITEM COMMENTS
export const get_library_meal_comments = async ({ meal_id }) => {
  try {
    // Build query params conditionally
    let queryParams = '';
    if (meal_id) {
      const params = new URLSearchParams();
      if (meal_id) params.append('meal_id', meal_id);

      queryParams = `?${params.toString()}`;
    }

    const res = await axios.get(`${endpoints.library.get_nutrition_meal_comments}${queryParams}`);
    return res; // Return the response data
  } catch (error) {
    console.error('Error getting comments:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD LIBRARY MEAL ITEM COMMENT MEDIA ( IMAGE OR VIDEO )
export const add_library_meal_comment_media = async ({ type, file }) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    file && formData.append('media', file);
    type && formData.append('type', type);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.upload_nutrition_meal_comment_media, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding video:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};

// ADD LIBRARY MEAL ITEM COMMENT
export const add_library_meal_comment = async ({
  parent_id,
  meal_id,
  comment,
  comment_media_ids,
}) => {
  try {
    // Create a new FormData instance
    const formData = new FormData();
    // Append fields to the FormData object
    meal_id && formData.append('meal_id', meal_id);
    parent_id && formData.append('parent_id', parent_id);
    comment && formData.append('comment', comment);
    comment_media_ids && formData.append('comment_media_ids', comment_media_ids);

    // Send the request using FormData with progress tracking
    const res = await axios.post(endpoints.library?.save_nutrition_meal_comment, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    });
    return res.data; // Return the response data
  } catch (error) {
    console.error('Error adding comment:', error);
    throw error; // Rethrow the error to handle it in the UI
  }
};
